<template>
    <common-swipper
      heading="What our clients say"
      sub-heading="Testimonials"
      :items="testimonials"
      :CardComponent="CommonTestimonialCard"
      testimonial
    />
  </template>
  
  <script setup>
  import { CommonTestimonialCard } from "#components";
  
  const testimonials = [
  {
    image: "/images/testimonials/yattan.webp",
    name: "Yattan S.",
    profession: "Educationist",
    description: "This was the simplest investment experience I've come across.  Kudos to the team for a smooth, distraction-free experience.",
  },
  {
    image: "/images/testimonials/abhayR.webp",
    name: "Abhay R.",
    profession: "Procurement Ops Lead",
    description: "Amazing that I can book high return FDs with any bank without opening an account.  The whole process was simple and straightforward.",
  },
  {
    image: "/images/testimonials/snehalP.webp",
    name: "Snehal P.",
    profession: "Architect & Entrepreneur",
    description: "Very courteous team that clarified my doubts with patience.",
  },
  {
    image: "/images/testimonials/aditi.webp",
    name: "Aditi Bhandari",
    profession: "VP Marketing",
    description: "Equirize has become my go to for finding highest return FDs in one glance.",
  },
  {
    image: "/images/testimonials/bharti.webp",
    name: "Bharti B.",
    profession: "CA",
    description: "Before Equirize, I was not aware that banks offer different/competitive FD rates.  I now finally optimize my FD returns.  Every percent matters and compounds in the long-run",
  },
  {
    image: "/images/testimonials/tanviK.webp",
    name: "Tanvi K.",
    profession: "Consultant",
    description: "I now book multiple small FDs for flexibility and different goals. Thank you for making this easy.",
  },
  {
    image: "/images/testimonials/tahurK.webp",
    name: "Tahura K",
    profession: "Entrepreneur",
    description: "I am now earning the maximum possible on my FDs. Thank you.",
  },
  {
    image: "/images/testimonials/saurabh.webp",
    name: "Saurabh Saraf",
    profession: "Entrepreneur-Climate Finance",
    description: "Fixed Deposits are the best way to save and secure fixed returns with the flexibility of breaking anytime.  Equirise offers the highest returns fixed deposits to maximise returns.",
  },
  {
    image: "/images/testimonials/nitin-negi.webp",
    name: "Nitin Negi",
    profession: "Agritech Entrepreneur",
    description: "Equirize team explained the process to me with clarity and patience. Appreciate the support team's quick response.",
  },
  {
    image: "/images/testimonials/ayush.webp",
    name: "Ayush G.",
    profession: "IT Professional",
    description: "I was happy to see a commitment towards the Sustainable Development Goals especially in an environment where investors want transparent answers on the outcome of their investments.",
  },
//   {
//     image: "/images/testimonials/shoeb.webp",
//     name: "Shoeb K.",
//     profession: "Corporate Leader",
//     description: "I have been investing in bonds for the past 5 years.  With equirise I explored listed bonds for the first time and like that they offer better protection via regulation.",
//   },
//   {
//     image: "/images/testimonials/pradeepJ.webp",
//     name: "Pradeep J",
//     profession: "Retired Army",
//     description: "My introduction to equirize was through one of its blog posts. Like many new investors, I considered FD with my existing bank, some stocks and Mutual funds as the only options. I've discovered so much about fixed income options here and am looking forward to the fruits of my first investment with equirize.",
//   },
  {
    image: "/images/testimonials/sapan.webp",
    name: "Sapan",
    profession: "Product Manager",
    description: "I was recommended to the Equirize platform by my brother for a clean, jargon-free investing experience and it was.  I recommend it further.",
  },
  {
    image: "/images/testimonials/manish.webp",
    name: "Manish Jasyal",
    profession: "Product Manager",
    description: "This is a great option for those who are looking to diversify from the stock market.  There are some great opportunities and optimization that retail investors can accomplish with debt opportunities.",
  },
//   {
//     image: "/images/testimonials/adill.webp",
//     name: "Adil",
//     profession: "Musician",
//     description: "This was my first time exploring investing in bonds.",
//   },
//   {
//     image: "/images/testimonials/sunanda.webp",
//     name: "Sunanda G.",
//     profession: "Professional",
//     description: "Bonds, their different types and variation in FD returns were overwhelming to understand. I appreciate that Equirize made it simple for me as a user to navigate and understand risks associated. Special shout out to the support team for being patient and transparent on the risks involved.",
//   },
//   {
//     image: "/images/testimonials/luv.webp",
//     name: "Luv N.",
//     profession: "Consultant",
//     description: "As a young parent, I want companies that are doing positive work to succeed and look forward to investing in sustainable development goals aligned bonds on equirize.  ",
//   },
];
  </script>